// @flow

export type InType = 'in';

export default class InFilter {
  type: InType;
  dimension: string;
  values: $ReadOnlyArray<string | null>;
  fields: void;
  field: void;
  pattern: void;

  constructor(dimension: string, values: $ReadOnlyArray<string | null>) {
    this.type = 'in';
    this.dimension = dimension;
    this.values = values;
  }
}
